/**
 * i18n keys for an assistant refusal, most specific first (#765 Ф2).
 *
 * The codes are shared by the record and the deal contours, and the record
 * wording is wrong for a deal: «The record was not found» for an agent who
 * sees none of the deal's conversations, «belongs to another record» for a
 * deal's thread (#1041 review). A deal reads its own wording where one
 * exists and falls back to the shared one where the wording fits both.
 */

import type { AssistantScope } from '@aica/api-types/schemas';

export function assistantErrorKeys(code: string, scope: AssistantScope): string[] {
  const shared = [`errors.${code}`, 'errors.generic'];
  if (scope === 'entity') return [`errorsEntity.${code}`, ...shared];
  // The whole base has no single record: «the record was not found» or «no
  // longer visible» would name something the user never picked (#765 Ф3).
  if (scope === 'org') return [`errorsOrg.${code}`, ...shared];
  return shared;
}
